import React, { FC } from 'react';
import { Blocks } from  'react-loader-spinner'

const LoaderSpinner: FC = () => {
    return (
        <div className="full-page-loader">
          <Blocks
    height="100"
    width="100"
    color={'grey'}
    ariaLabel='loading'
  />
        </div>
    );
};

export default LoaderSpinner;